import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import {
  getFlightsResponseBody,
  isResponseContainFlightsBody,
  isFlightsResponseError,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import keyBy from 'lodash/keyBy';

import { mapCarriers } from './carriersMapper';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { CarrierState } from '@web-platform/shared-universal-types/src/redux/state/entities/flights/carriers';

export type {
  Carrier,
  CarrierState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/carriers';

export const INITIAL_STATE: CarrierState = {
  byId: {},
  multiple: null,
  currentResultIds: [],
};

const carriersReducer = (state: CarrierState = INITIAL_STATE, action: Action): CarrierState => {
  switch (action.type) {
    case SEARCH_PARAMS_CHANGED:
      return INITIAL_STATE;

    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      if (action.payload.type === RADAR_CREATE_SESSIONS || action.payload.type === RADAR_POLL) {
        if (
          isFlightsResponseError(action.payload.response) ||
          !isResponseContainFlightsBody(action.payload.response)
        ) {
          return state;
        }

        const flightsResponseBody = getFlightsResponseBody(action.payload.response);
        const { carriers, currentResultIds, multiple } = mapCarriers(
          flightsResponseBody.results || [],
          flightsResponseBody.filterStats,
        );

        return {
          byId: { ...state.byId, ...keyBy(carriers, (carrier) => carrier.id) },
          multiple: multiple ?? state.multiple,
          currentResultIds,
        };
      }

      return state;
    }

    default:
      return state;
  }
};

export default carriersReducer;
